import 'core-js/stable';
import 'regenerator-runtime/runtime';

// See https://babeljs.io/docs/en/babel-preset-env#usebuiltins
// Babel polyfill has been deprecated in Babel 7.4.0
// Since it was a wrapper already around core-js, it is recommended to directly add core-js
// These two import statements are necessary in our entry js and will trigger replacement with the correct polyfills
